import { memo, useState } from 'react';
import StackTextField from 'components/cmn/StackTextField';
import useWidth from 'hooks/useWidth';
import { Button, Stack } from '@mui/material';
import isEmpty from 'lodash/isEmpty';
import { useAppDispatch } from 'store';
import { showMessage } from 'store/message/messageSlice';
import { useProject } from 'hooks/useProject';

function ProjectSearch(): JSX.Element {
  const dispatch = useAppDispatch();
  const { changeProjectListSearchCondition, projectListSearchCondition } = useProject();
  const [compName, setCompName] = useState('');
  const [adminName, setAdminName] = useState('');

  const width = useWidth();
  const isPc = ['lg', 'xl'].includes(width);
  const isTablet = ['md'].includes(width);
  const isMobile = ['xs', 'sm'].includes(width);
  let dynamicWidth = '400px';
  if (isPc) {
    dynamicWidth = '400px';
  } else if (isTablet) {
    dynamicWidth = '250px';
  } else if (isMobile) {
    dynamicWidth = '100%';
  }

  const handleSearchClick = () => {
    if (isEmpty(compName) && isEmpty(adminName)) {
      dispatch(showMessage({ message: '적어도 하나의 필드는 입력해야합니다.', variant: 'warning' }));
    }
    changeProjectListSearchCondition({
      ...projectListSearchCondition,
      compName,
      adminName,
    });
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      handleSearchClick();
    }
  };

  return (
    <Stack
      direction={isMobile ? 'column' : 'row'}
      spacing="24px"
      sx={{ display: 'flex', alignItems: 'center', pt: 2, justifyContent: 'flex-start' }}
    >
      <Stack
        direction="column"
        sx={{ display: 'flex', alignItems: isMobile ? 'flex-start' : 'center', p: 0, overflow: 'auto' }}
      >
        <StackTextField
          essential={false}
          label="프로젝트 기업명"
          name="compName"
          text={compName}
          directionType="custom"
          labelSx={{ fontSize: 16, fontWeight: 700 }}
          labelWidth={110}
          width={dynamicWidth}
          onChange={e => setCompName(e.target.value)}
          onKeyPress={handleKeyPress}
        />
        <StackTextField
          essential={false}
          label="프로젝트 담당자"
          name="adminName"
          text={adminName}
          directionType="custom"
          labelSx={{ fontSize: 16, fontWeight: 700 }}
          labelWidth={110}
          width={dynamicWidth}
          onChange={e => setAdminName(e.target.value)}
        />
      </Stack>
      <Button variant="contained" color="primary" onClick={handleSearchClick} sx={{ height: 40 }}>
        프로젝트 검색
      </Button>
    </Stack>
  );
}

export default memo(ProjectSearch);
